// The import window: each step comes from the server as a whole modal and replaces the current one.
// It can open on any page (accounts, transactions), so the handlers live on the document.

const modalContent = node => node.closest('.modal-content');

function busy(content, on) {
    content.querySelectorAll('[data-import-submit], [data-import-back], button[type="submit"]').forEach(button => {
        button.disabled = on;
        button.classList.toggle('disabled', on);
    });
    content.classList.toggle('ms-import-busy', on);
}

async function swap(content, request) {
    busy(content, true);
    try {
        const response = await request;
        const html = await response.text();
        const next = new DOMParser().parseFromString(html, 'text/html').querySelector('.modal-content');
        if (!next) {
            // the session ended: the server answered with the login page
            window.location.reload();
            return;
        }
        content.replaceWith(document.importNode(next, true));
    } catch (e) {
        busy(content, false);
        console.error('import step failed', e);
    }
}

// one column per role: choosing a role for a column takes it from the one that had it
function syncRoles(form, changed) {
    const selects = [...form.querySelectorAll('select[data-import-role]')];
    if (changed && changed.value !== 'skip') {
        selects.filter(other => other !== changed && other.value === changed.value).forEach(other => { other.value = 'skip'; });
    }
    selects.forEach(select => select.closest('[data-import-column]')?.classList.toggle('border-primary', select.value !== 'skip'));

    // the settings that matter for the chosen columns only
    const roles = selects.map(select => select.value);
    form.querySelector('[data-import-when="amount"]')?.classList.toggle('d-none', !roles.includes('amount'));
    form.querySelector('[data-import-when="no-tags"]')?.classList.toggle('d-none', roles.includes('tags'));
    form.querySelector('[data-import-when="category"]')?.classList.toggle('d-none', !roles.includes('category'));
}

const sampleTimers = new WeakMap();

// the result under the columns, parsed on the server by the same code as the import
function refreshSample(form) {
    clearTimeout(sampleTimers.get(form));
    sampleTimers.set(form, setTimeout(async () => {
        const target = form.querySelector('[data-import-sample]');
        if (!target) {
            return;
        }
        target.classList.add('opacity-50');
        try {
            const response = await fetch(form.dataset.sampleUrl, { method: 'POST', body: new FormData(form), credentials: 'same-origin' });
            const html = await response.text();
            const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-import-sample]');
            if (next) {
                target.replaceWith(document.importNode(next, true));
                const format = form.querySelector('#import-DateFormat');
                if (format && next.dataset.dateFormat && format.value !== next.dataset.dateFormat) {
                    format.value = next.dataset.dateFormat;
                }
                return;
            }
        } catch (e) {
            console.error('import sample failed', e);
        }
        target.classList.remove('opacity-50');
    }, 250));
}

document.addEventListener('submit', event => {
    const form = event.target.closest('form[data-import-form]');
    if (!form) {
        return;
    }
    event.preventDefault();
    if (form.dataset.confirm && !window.confirm(form.dataset.confirm)) {
        return;
    }
    const content = modalContent(form);
    swap(content, fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' }));
});

document.addEventListener('click', event => {
    const back = event.target.closest('[data-import-back]');
    if (back) {
        event.preventDefault();
        swap(modalContent(back), fetch(back.dataset.importBack, { credentials: 'same-origin' }));
        return;
    }

    // new transactions belong on the page underneath
    if (event.target.closest('[data-import-close]')) {
        window.location.reload();
    }
});

document.addEventListener('change', event => {
    const account = event.target.closest('select[data-import-reload]');
    if (account) {
        const url = new URL(account.dataset.importReload, window.location.origin);
        url.searchParams.set('account_id', account.value);
        swap(modalContent(account), fetch(url, { credentials: 'same-origin' }));
        return;
    }

    // another separator gives other columns, so the whole step comes back
    const delimiter = event.target.closest('select[data-import-delimiter]');
    if (delimiter) {
        const form = delimiter.closest('form');
        swap(modalContent(form), fetch(delimiter.dataset.importDelimiter, { method: 'POST', body: new FormData(form), credentials: 'same-origin' }));
        return;
    }

    const map = event.target.closest('form[data-import-map]');
    if (map) {
        if (event.target.matches('select[data-import-role]')) {
            syncRoles(map, event.target);
        }
        refreshSample(map);
    }
});

document.addEventListener('input', event => {
    const map = event.target.closest('form[data-import-map]');
    if (map && event.target.name === 'DefaultTag') {
        refreshSample(map);
    }
});
